var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-small":"","outlined":"","rounded":"","color":"secondary"},on:{"click":_vm.download}},[_vm._v("PDF")])
}
var staticRenderFns = []

export { render, staticRenderFns }